export default {
  'pages.covenantDevice.mac': 'MACアドレス',
  'pages.admin.providerCard.config.grpcAddr': 'gRPCアドレス',
  'pages.covenantDevice.cardTitle': '契約デバイス管理',
  'pages.admin.whitelist.mac': 'MACアドレス',
  'pages.covenantDevice.operations': '操作',
  'pages.covenantDevice.expireTime': '有効期限',
  'pages.covenantDevice.updateTime': '更新時間',
  'pages.unbindDevice.titleAdmin': 'デバイスの解除（管理者権限が必要）',
  'pages.unbindDevice.inputPlaceholder': 'デバイスIDを入力してください',
  'pages.unbindDevice.unbind': '解除',
  'pages.unbindDevice.unbinding': '解除中...',
  'pages.unbindDevice.success': '解除成功',
  'pages.unbindDevice.fail': '解除失敗',
  'pages.layouts.userLayout.title': '管理コンソール',
  'pages.login.accountLogin.tab': 'アカウントログイン',
  'pages.login.accountLogin.errorMessage':
    'ユーザー名/パスワードが間違っています（admin/ant.design）',
  'pages.login.failure': 'ログインに失敗しました。もう一度お試しください！',
  'pages.login.success': 'ログイン成功！',
  'pages.login.username.placeholder': 'ユーザー名: adminまたはuser',
  'pages.login.username.required': 'ユーザー名を入力してください！',
  'pages.login.password.placeholder': 'パスワード: ant.design',
  'pages.login.password.required': 'パスワードを入力してください！',
  'pages.login.phoneLogin.tab': '電話ログイン',
  'pages.login.phoneLogin.errorMessage': '認証コードエラー',
  'pages.login.phoneNumber.placeholder': '電話番号',
  'pages.login.phoneNumber.required': '電話番号を入力してください！',
  'pages.login.phoneNumber.invalid': '電話番号が無効です！',
  'pages.login.captcha.placeholder': '認証コード',
  'pages.login.captcha.required': '認証コードを入力してください！',
  'pages.login.phoneLogin.getVerificationCode': 'コード取得',
  'pages.getCaptchaSecondText': '秒',
  'pages.login.rememberMe': 'ログイン状態を保持',
  'pages.login.forgotPassword': 'パスワードをお忘れですか？',
  'pages.login.submit': 'ログイン',
  'pages.login.loginWith': 'ログイン方法：',
  'pages.login.registerAccount': 'アカウント登録',
  'pages.welcome.link': 'ようこそ',
  'pages.welcome.alertMessage':
    'より高速で強力なヘビーデューティコンポーネントがリリースされました。',
  'pages.404.subTitle': '申し訳ございません。アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみ表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験を開始してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール設定',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルール説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '少なくとも5文字入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '少なくとも5文字のルール説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティ設定',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名は必須です',
  'pages.searchTable.titleCallNo': 'サービス呼び出し回数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '実行中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '設定',
  'pages.searchTable.subscribeAlert': 'アラートを購読',
  'pages.searchTable.title': '問い合わせフォーム',
  'pages.searchTable.new': '新規',
  'pages.searchTable.chosen': '選択済み',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': '総サービス呼び出し回数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '一括削除',
  'pages.searchTable.batchApproval': '一括承認',
  
  // Agents page related text
  'pages.agents.search.placeholder': 'エージェントを検索',
  'pages.agents.create.button': 'エージェント作成',
  'pages.agents.addDevice.button': 'デバイス追加',
  'pages.agents.create.modal.title': 'エージェント作成',
  'pages.agents.create.modal.nameLabel': 'エージェント名',
  'pages.agents.create.modal.placeholder': 'エージェント名を入力してください',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': '音声モデル',
  'pages.agents.card.languageModel': '言語モデル',
  'pages.agents.card.lastChat': '最後のチャット',
  'pages.agents.card.conversationId': '会話ID',
  'pages.agents.card.clearConversation': '会話IDをクリア',
  'pages.agents.card.clearConversation.success': '会話IDがクリアされました',
  'pages.agents.card.clearConversation.error': '会話IDのクリアに失敗しました',
  'pages.agents.card.configRole': '役割設定',
  'pages.agents.card.voiceRecognition': '音声認識',
  'pages.agents.card.voiceRecognition.developing': '機能開発中です。お楽しみに',
  'pages.agents.card.historyDialog': '履歴ダイアログ',
  'pages.agents.card.manageDevice': 'デバイス管理',
  'pages.agents.card.addDevice': 'デバイス追加',
  'pages.agents.loading': 'エージェントリストを読み込み中...',
  'pages.agents.reload': '再読み込み',
  'pages.agents.empty.title': '利用可能なエージェントがありません',
  'pages.agents.empty.createFirst': '最初のエージェントを作成',
  'pages.agents.delete.title': 'エージェント削除の確認',
  'pages.agents.delete.content': 'エージェントを削除すると、関連するすべての設定（デバイス関連の会話記録を含む）は復元できません。削除してもよろしいですか？',
  'pages.agents.delete.confirm': '削除確認',
  'pages.agents.fetch.error': 'エージェントリストの取得に失敗しました',
  'pages.agents.network.error': 'ネットワークエラー。後でもう一度お試しください',
  'pages.agents.speed.patient': 'ゆっくり',
  'pages.agents.speed.normal': '普通',
  'pages.agents.speed.fast': '速い',
  'pages.agents.lastChat.none': 'なし',
  'pages.agents.language.chinese': '中国語',
  'pages.agents.loading.tts.error': 'TTS音声の読み込みに失敗しました',
  'pages.agents.loading.llm.error': 'LLMプロバイダーの読み込みに失敗しました',
  'pages.agents.sort.id': 'IDで並べ替え',
  'pages.agents.sort.updatedAt': '最終更新で並べ替え',
  'pages.agents.sort.lastConversationAt': '最終会話で並べ替え',
  
  // Register page related text
  'pages.register': '登録',
  'pages.register.title': '登録',
  'pages.register.form.title': '新しいアカウントを登録',
  'pages.register.submit': '登録',
  'pages.register.username.placeholder': 'ユーザー名を入力してください',
  'pages.register.username.required': 'ユーザー名を入力してください！',
  'pages.register.username.min': 'ユーザー名は少なくとも4文字である必要があります',
  'pages.register.email.placeholder': 'メールアドレスを入力してください',
  'pages.register.email.required': 'メールアドレスを入力してください！',
  'pages.register.email.invalid': '有効なメールアドレスを入力してください！',
  'pages.register.password.placeholder': 'パスワードを入力してください',
  'pages.register.password.required': 'パスワードを入力してください！',
  'pages.register.password.min': 'パスワードは少なくとも6文字である必要があります',
  'pages.register.password.pattern': 'パスワードには大文字、小文字、数字を含める必要があります',
  'pages.register.confirmPassword.placeholder': 'パスワードを確認してください',
  'pages.register.confirmPassword.required': 'パスワードを確認してください！',
  'pages.register.confirmPassword.min': 'パスワードは少なくとも6文字である必要があります',
  'pages.register.error.passwordMismatch': '2つのパスワードが一致しません',
  'pages.register.error.registerFailed': '登録に失敗しました。もう一度お試しください！',
  'pages.register.success': '登録成功！',
  
  // Login page related text
  'pages.login.title': 'アニメAIチャット管理コンソール',
  'pages.login.actionIcons.notImplemented': 'まだ実装されていません。近日公開予定',
  'pages.login.mobile.captchaError': '認証コードエラー',
  'pages.login.captcha.success': '認証コードが正常に送信されました！コード：1234',
  'pages.login.forgotPassword.contactAdmin': '管理者にお問い合わせください',
  'pages.login.mobile.notAvailable': 'この機能はまだ利用できません。アカウントログインを使用してください',
  
  // AgentSetting page related text
  'pages.agentSetting.title': '役割設定',
  'pages.agentSetting.back': '戻る',
  'pages.agentSetting.roleTemplate.title': '役割テンプレート',
  'pages.agentSetting.roleTemplate.label': 'テンプレート',
  'pages.agentSetting.template.taiwanGirlfriend': '台湾の彼女',
  'pages.agentSetting.template.potato': 'ポテト',
  'pages.agentSetting.template.englishTutor': '英語講師',
  'pages.agentSetting.template.curiousBoy': '好奇心旺盛な男の子',
  'pages.agentSetting.template.puppyLeader': '子犬のリーダー',
  'pages.agentSetting.basicConfig.title': '基本設定',
  'pages.agentSetting.assistantName.label': 'アシスタント名',
  'pages.agentSetting.assistantName.placeholder': 'アシスタント名を入力してください',
  'pages.agentSetting.assistantName.required': 'アシスタント名を入力してください',
  'pages.agentSetting.dialogLanguage.label': 'ダイアログ言語',
  'pages.agentSetting.dialogLanguage.placeholder': 'ダイアログ言語を選択',
  'pages.agentSetting.voiceType.label': '音声タイプ',
  'pages.agentSetting.voiceType.placeholder': '音声タイプを選択',
  'pages.agentSetting.roleDescription.title': '役割説明',
  'pages.agentSetting.roleDescription.label': '役割説明',
  'pages.agentSetting.roleDescription.placeholder': '役割説明を入力してください',
  'pages.agentSetting.roleDescription.required': '役割説明を入力してください',
  'pages.agentSetting.languageModel.title': '言語モデル',
  'pages.agentSetting.languageModel.label': '言語モデル',
  'pages.agentSetting.languageModel.placeholder': '言語モデルを選択',
  'pages.agentSetting.languageModel.tip': 'モデルを変更した後は、チャット体験に影響を与えないようにメモリをクリアすることをお勧めします。',
  'pages.agentSetting.advancedSettings.expand': '詳細設定を展開',
  'pages.agentSetting.advancedSettings.collapse': '詳細設定を折りたたむ',
  'pages.agentSetting.recognitionSpeed.label': '音声認識速度',
  'pages.agentSetting.recognitionSpeed.placeholder': '認識速度を選択',
  'pages.agentSetting.speechSpeed.label': '音声速度',
  'pages.agentSetting.speechSpeed.placeholder': '音声速度を選択',
  'pages.agentSetting.pitchValue.label': 'キャラ音量',
  'pages.agentSetting.button.reset': 'リセット',
  'pages.agentSetting.button.save': '保存',
  'pages.agentSetting.save.success': '保存成功',
  'pages.agentSetting.save.error': '保存失敗',
  'pages.agentSetting.save.missingId': 'エージェントIDが見つかりません。保存できません',
  'pages.agentSetting.load.tts.error': 'TTS音声の読み込みに失敗しました',
  'pages.agentSetting.speed.slow': 'ゆっくり',
  'pages.agentSetting.speed.normal': '普通',
  'pages.agentSetting.speed.fast': '速い',
  'pages.agentSetting.speed.patient': 'ゆっくり',
  'pages.agentSetting.language.chinese': '中国語',
  'pages.agentSetting.language.english': '英語',
  'pages.agentSetting.language.spanish': 'スペイン語',
  'pages.agentSetting.language.french': 'フランス語',
  'pages.agentSetting.language.german': 'ドイツ語',
  'pages.agentSetting.language.japanese': '日本語',
  'pages.agentSetting.language.korean': '韓国語',
  'pages.agentSetting.language.portuguese': 'ポルトガル語',
  'pages.agentSetting.language.arabic': 'アラビア語',
  'pages.agentSetting.language.russian': 'ロシア語',
  'pages.agentSetting.language.italian': 'イタリア語',
  'pages.agentSetting.language.turkish': 'トルコ語',
  'pages.agentSetting.language.polish': 'ポーランド語',
  'pages.agentSetting.language.catalan': 'カタルーナ語',

  // DeviceManagement page related text
  'pages.devices.title': 'デバイス管理',
  'pages.devices.breadcrumb.agents': 'エージェント',
  'pages.devices.breadcrumb.devices': 'デバイス管理',
  'pages.devices.button.addDevice': 'デバイス追加',
  'pages.devices.warning.noAgentId': 'agentIdが指定されていないため、デバイスリストを取得できません',
  'pages.devices.device.unnamed': '名前なしデバイス',
  'pages.devices.device.macAddress': 'MACアドレス',
  'pages.devices.device.lastActive': '最終アクティブ',
  'pages.devices.device.firmwareVersion': 'ファームウェアバージョン',
  'pages.devices.device.otaUpgrade': 'OTAアップグレード',
  'pages.devices.device.noData': 'データなし',
  'pages.devices.copy.success': 'MACアドレスがコピーされました',
  'pages.devices.unbind.title': 'デバイス解除の確認',
  'pages.devices.unbind.content': 'デバイスの解除は復元できません。再度使用する場合は再バインドが必要です。解除してもよろしいですか？',
  'pages.devices.unbind.confirm': '解除確認',
  'pages.devices.unbind.cancel': 'キャンセル',
  'pages.devices.unbind.success': 'デバイスが解除されました',
  'pages.devices.unbind.error': '解除に失敗しました',
  'pages.devices.ota.enabled': 'OTAアップグレードが有効',
  'pages.devices.ota.disabled': 'OTAアップグレードが無効',
  
  // HistoryDialogs page related text
  'pages.historyDialogs.title': '履歴ダイアログ',
  'pages.historyDialogs.breadcrumb.agents': 'エージェント',
  'pages.historyDialogs.breadcrumb.historyDialogs': '履歴ダイアログ',
  'pages.historyDialogs.empty.title': '会話が選択されていません',
  'pages.historyDialogs.empty.description': '会話を選択してください',
  'pages.historyDialogs.agent': 'エージェント',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': '会話詳細',
  'pages.historyDialogs.selectConversation': '会話を選択してください',
  'pages.historyDialogs.delete.title': '会話削除',
  'pages.historyDialogs.delete.content': '削除後は会話を復元できません。操作を確認してください。',
  'pages.historyDialogs.delete.confirm': '確認',
  'pages.historyDialogs.delete.cancel': 'キャンセル',
  'pages.historyDialogs.message.delete.confirm': 'このメッセージを削除してもよろしいですか？削除後は復元できません。',
  'pages.historyDialogs.detail.title': '会話詳細',
  'pages.historyDialogs.agent.label': 'エージェント：',
  'pages.historyDialogs.user.label': 'ユーザー：',
  'pages.historyDialogs.loading': '読み込み中...',
  'pages.historyDialogs.error.loadFailed': '会話リストの読み込みに失敗しました',
  'pages.historyDialogs.error.deleteFailed': '会話の削除に失敗しました',
  'pages.historyDialogs.success.deleteSuccess': '会話が正常に削除されました',
  
  // MessageList page related text
  'pages.messageList.empty': 'メッセージがありません',
  'pages.messageList.user': 'ユーザー',
  'pages.messageList.ai': 'AI',
  
  // Settings page related text
  'pages.settings.basicInfo.title': '基本情報',
  'pages.settings.avatar.label': 'アバター：',
  'pages.settings.avatar.change': 'アバター変更',
  'pages.settings.avatar.updateSuccess': 'アバターが正常に更新されました',
  'pages.settings.avatar.updateFailed': 'アバターの更新に失敗しました',
  'pages.settings.username.label': 'ユーザー名：',
  'pages.settings.nickname.label': 'ニックネーム：',
  'pages.settings.nickname.change': 'ニックネーム編集',
  'pages.settings.nickname.modal.title': 'ニックネーム編集',
  'pages.settings.nickname.form.label': '新しいニックネーム',
  'pages.settings.nickname.form.required': '新しいニックネームを入力してください',
  'pages.settings.nickname.form.length': 'ニックネームの長さは2-20文字である必要があります',
  'pages.settings.nickname.updateSuccess': 'ニックネームが正常に更新されました',
  'pages.settings.nickname.updateFailed': 'ニックネームの更新に失敗しました',
  'pages.settings.registerTime.label': '登録時間：',
  'pages.settings.email.label': 'メール：',
  'pages.settings.email.unbind': '未バインド',
  'pages.settings.email.bind': 'メールバインド',
  'pages.settings.email.change': 'メール変更',
  'pages.settings.email.modal.title': 'メールバインド',
  'pages.settings.email.modal.changeTitle': 'メール変更',
  'pages.settings.email.form.label': 'メール',
  'pages.settings.email.form.required': 'メールを入力してください',
  'pages.settings.email.form.invalid': 'メール形式が無効です',
  'pages.settings.email.bindSuccess': 'メールが正常にバインドされました',
  'pages.settings.email.bindFailed': 'メールのバインドに失敗しました',
  'pages.settings.changePassword.title': 'パスワード変更',
  'pages.settings.changePassword.button': 'パスワード変更',
  'pages.settings.changePassword.modal.title': 'パスワード変更',
  'pages.settings.changePassword.oldPassword.label': '古いパスワード',
  'pages.settings.changePassword.oldPassword.required': '古いパスワードを入力してください',
  'pages.settings.changePassword.newPassword.label': '新しいパスワード',
  'pages.settings.changePassword.newPassword.required': '新しいパスワードを入力してください',
  'pages.settings.changePassword.newPassword.min': '新しいパスワードは少なくとも6文字である必要があります',
  'pages.settings.changePassword.confirmPassword.label': '新しいパスワードを確認',
  'pages.settings.changePassword.confirmPassword.required': '新しいパスワードを確認してください',
  'pages.settings.changePassword.confirmPassword.mismatch': 'パスワードが一致しません',
  'pages.settings.changePassword.success': 'パスワードが正常に変更されました',
  'pages.settings.changePassword.failed': 'パスワードの変更に失敗しました',
  'pages.settings.deleteAccount.title': 'アカウント削除',
  'pages.settings.deleteAccount.button': 'アカウント削除',
  'pages.settings.deleteAccount.confirm.title': 'アカウント削除の確認？',
  'pages.settings.deleteAccount.confirm.content': 'この操作は元に戻せません。アカウントを削除してもよろしいですか？',
  'pages.settings.deleteAccount.confirm.ok': '削除',
  'pages.settings.deleteAccount.confirm.cancel': 'キャンセル',
  'pages.settings.deleteAccount.success': 'アカウントが正常に削除されました',
  'pages.settings.deleteAccount.failed': 'アカウントの削除に失敗しました',
  'pages.settings.profile.fetchFailed': 'ユーザー情報の取得に失敗しました',
  'pages.settings.form.submit': '送信',
  'pages.settings.password.title': 'パスワード設定',
  'pages.settings.basicInfo.username': 'ユーザー名',
  'pages.settings.basicInfo.nickname': 'ニックネーム',
  'pages.settings.basicInfo.avatar': 'アバター',
  'pages.settings.basicInfo.editNickname': 'ニックネーム編集',
  'pages.settings.basicInfo.editNicknameTitle': 'ニックネーム編集',
  'pages.settings.basicInfo.newNicknameLabel': '新しいニックネーム',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'ニックネームが正常に変更されました',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': '送信',
  'pages.settings.deleteAccount.confirmTitle': 'アカウント削除の確認',
  'pages.settings.deleteAccount.confirmContent': 'アカウントを削除すると、すべてのデータが永久に削除され、復元できません。また、このアカウントでログインできなくなります。慎重に操作してください！',
  'pages.settings.deleteAccount.cancel': 'キャンセル',
  'pages.settings.deleteAccount.confirm': '削除確認',
  
  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'ユーザー数',
  'pages.admin.dashboard.deviceCount': 'デバイス数', 
  'pages.admin.dashboard.agentCount': 'エージェント数',
  'pages.admin.dashboard.onlineUsers': 'オンラインユーザー',
  'pages.admin.dashboard.sessionDevices': 'セッションデバイス',
  'pages.admin.dashboard.memoryUsage': 'メモリ使用量',
  'pages.admin.dashboard.cpuUsage': 'CPU使用量',
  'pages.admin.dashboard.fetchError': 'データの取得に失敗しました',
  'pages.admin.dashboard.networkError': 'ネットワークエラー',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'ユーザー名',
  'pages.admin.user.email': 'メール',
  'pages.admin.user.status': 'ステータス',
  'pages.admin.user.status.all': 'すべて',
  'pages.admin.user.status.disabled': '無効',
  'pages.admin.user.status.normal': '通常',
  'pages.admin.user.quotaUsed': '日次クォータ使用量',
  'pages.admin.user.quotaTotal': '日次クォータ合計',
  'pages.admin.user.createdAt': '作成日',
  'pages.admin.user.operations': '操作',
  'pages.admin.user.edit': '編集',
  'pages.admin.user.detail': '詳細',
  'pages.admin.user.editModal.title': 'ユーザー編集',
  'pages.admin.user.status.label': 'ユーザーステータス',
  'pages.admin.user.status.enable': '有効',
  'pages.admin.user.status.disable': '無効',
  'pages.admin.user.quotaUsed.label': '日次クォータ使用量',
  'pages.admin.user.quotaTotal.label': '日次クォータ合計',
  'pages.admin.user.email.label': 'メール',
  'pages.admin.user.save.success': '保存成功',
  'pages.admin.user.save.failed': '保存失敗',
  'pages.admin.user.list.title': 'ユーザーリスト',

  // Admin Model Providers
  'pages.admin.providers.title': 'モデルプロバイダー管理',
  'pages.admin.providers.total': '合計{total}プロバイダー',
  'pages.admin.providers.stats': 'ASR：{asr}、TTS：{tts}、LLM：{llm}、VLLLM：{vlllm}',
  'pages.admin.providers.addNew': '新しいプロバイダーを追加',
  'pages.admin.providers.search.placeholder': 'プロバイダー名、エンドポイント、またはモデルを検索...',
  'pages.admin.providers.filter.all': 'すべてのタイプ',
  'pages.admin.providers.filter.asr': 'ASR - 音声認識',
  'pages.admin.providers.filter.tts': 'TTS - テキスト読み上げ', 
  'pages.admin.providers.filter.llm': 'LLM - 大規模言語モデル',
  'pages.admin.providers.filter.vlllm': 'VLLLM - ビジョン言語モデル',
  'pages.admin.providers.empty.noProviders': 'プロバイダーがまだありません',
  'pages.admin.providers.empty.noMatches': '一致するプロバイダーが見つかりません',
  'pages.admin.providers.empty.addFirst': '上のボタンをクリックして最初のモデルプロバイダーを追加してください',
  'pages.admin.providers.empty.adjustFilters': '検索条件やフィルターを調整してみてください',
  'pages.admin.providers.type.asr': 'ASR - 音声認識',
  'pages.admin.providers.type.tts': 'TTS - テキスト読み上げ',
  'pages.admin.providers.type.llm': 'LLM - 大規模言語モデル',
  'pages.admin.providers.type.vlllm': 'VLLLM - ビジョン言語モデル',
  'pages.admin.providers.success.created': 'プロバイダーが正常に追加されました！',
  'pages.admin.providers.success.updated': 'プロバイダーが正常に更新されました！',
  'pages.admin.providers.success.deleted': 'プロバイダーが正常に削除されました！',
  'pages.admin.providers.success.statusToggled': 'ステータスが正常に切り替えられました！',
  'pages.admin.providers.error.createFailed': 'プロバイダーの追加に失敗しました。もう一度お試しください',
  'pages.admin.providers.error.updateFailed': 'プロバイダーの更新に失敗しました。もう一度お試しください',
  'pages.admin.providers.error.deleteFailed': 'プロバイダーの削除に失敗しました。もう一度お試しください',
  'pages.admin.providers.error.testFailed': '接続テストに失敗しました。ネットワークまたは設定を確認してください',
  'pages.admin.providers.error.toggleFailed': 'ステータスの切り替えに失敗しました。もう一度お試しください',
  'pages.admin.providers.error.loadFailed': 'プロバイダーリストの読み込みに失敗しました。ページを更新してください',

  // Admin Settings
  'pages.admin.settings.title': 'システム設定',
  'pages.admin.settings.asr.label': 'ASRサービス',
  'pages.admin.settings.asr.placeholder': 'ASRサービスを選択',
  'pages.admin.settings.tts.label': 'TTSサービス',
  'pages.admin.settings.tts.placeholder': 'TTSサービスを選択',
  'pages.admin.settings.llm.label': 'LLMサービス',
  'pages.admin.settings.llm.placeholder': 'LLMサービスを選択',
  'pages.admin.settings.vlllm.label': 'VLLLMサービス',
  'pages.admin.settings.vlllm.placeholder': 'VLLLMサービスを選択',
  'pages.admin.settings.prompt.label': 'プロンプト設定',
  'pages.admin.settings.prompt.placeholder': 'システムプロンプトを入力してください...',
  'pages.admin.settings.quickReply.label': 'クイック返信ワード',
  'pages.admin.settings.quickReply.placeholder': '新しいクイック返信ワードを入力',
  'pages.admin.settings.quickReply.add': '追加',
  'pages.admin.settings.deleteAudio.label': 'オーディオ削除',
  'pages.admin.settings.deleteAudio.enabled': '有効',
  'pages.admin.settings.deleteAudio.disabled': '無効',
  'pages.admin.settings.usePrivateConfig': 'プライベート設定を使用',
  'pages.admin.settings.save': '設定を保存',
  'pages.admin.settings.saving': '保存中...',
  'pages.admin.settings.reset': 'リセット',
  'pages.admin.settings.success.saved': '設定が正常に保存されました！',
  'pages.admin.settings.error.saveFailed': '設定の保存に失敗しました。もう一度お試しください',
  'pages.admin.settings.error.loadFailed': '設定の読み込みに失敗しました。ページを更新してもう一度お試しください',


  // Add Device Dialog
  'pages.addDevice.modal.title': 'デバイス追加',
  'pages.addDevice.verificationCode.label': '認証コード：',
  'pages.addDevice.verificationCode.placeholder': 'デバイスからの6桁認証コードを入力してください',
  'pages.addDevice.verificationCode.required': '6桁の認証コードを入力してください',
  'pages.addDevice.verificationCode.error': '6桁の認証コードを入力してください',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'プロバイダー編集',
  'pages.admin.providerModal.add.title': '新しいプロバイダーを追加',
  'pages.admin.providerModal.name.label': 'プロバイダー名 *',
  'pages.admin.providerModal.name.placeholder': '例：OpenAI、Doubao TTS',
  'pages.admin.providerModal.name.required': 'プロバイダー名を入力してください',
  'pages.admin.providerModal.type.label': 'サービスカテゴリ *',
  'pages.admin.providerModal.subType.label': '具体的なタイプ *',
  'pages.admin.providerModal.subType.required': '具体的なタイプを選択してください',
  'pages.admin.providerModal.config.title': '設定',
  'pages.admin.providerModal.api.url.label': 'API URL *',
  'pages.admin.providerModal.api.url.required': 'API URLを入力してください',
  'pages.admin.providerModal.model.name.label': 'モデル名 *',
  'pages.admin.providerModal.model.name.required': 'モデル名を入力してください',
  'pages.admin.providerModal.api.key.label': 'APIキー *',
  'pages.admin.providerModal.api.key.required': 'APIキーを入力してください',
  'pages.admin.providerModal.temperature.label': '温度（0-2）',
  'pages.admin.providerModal.temperature.error': '温度は0-2の間である必要があります',
  'pages.admin.providerModal.maxTokens.label': '最大トークン数',
  'pages.admin.providerModal.maxTokens.error': '最大トークン数は1-32768の間である必要があります',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'アプリID *',
  'pages.admin.providerModal.appid.required': 'アプリIDを入力してください',
  'pages.admin.providerModal.accessToken.label': 'アクセストークン *',
  'pages.admin.providerModal.accessToken.required': 'アクセストークンを入力してください',
  'pages.admin.providerModal.cluster.label': 'クラスター',
  'pages.admin.providerModal.grpc.host.label': 'gRPCホスト *',
  'pages.admin.providerModal.grpc.host.required': 'gRPCホストアドレスを入力してください',
  'pages.admin.providerModal.grpc.port.label': 'gRPCポート *',
  'pages.admin.providerModal.grpc.port.required': 'gRPCポートを入力してください',
  'pages.admin.providerModal.voice.label': '音声 *',
  'pages.admin.providerModal.voice.required': '音声タイプを入力してください',
  'pages.admin.providerModal.token.label': 'トークン *',
  'pages.admin.providerModal.token.required': 'トークンを入力してください',
  'pages.admin.providerModal.websocket.label': 'WebSocket URL *',
  'pages.admin.providerModal.websocket.required': 'WebSocket URLを入力してください',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'APIキー *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'APIキーを入力してください',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'API URL',
  'pages.admin.providerModal.manage.voices': '音声管理',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTSは追加設定が不要です',
  'pages.admin.providerModal.submit.error': '送信に失敗しました。もう一度お試しください',

  // Provider Card
  'pages.admin.providerCard.status.active': 'アクティブ',
  'pages.admin.providerCard.status.inactive': 'オフライン',
  'pages.admin.providerCard.status.error': 'エラー',
  'pages.admin.providerCard.status.unknown': '不明',
  'pages.admin.providerCard.warning.readonly.test': '読み取り専用権限のため、プロバイダーをテストできません',
  'pages.admin.providerCard.warning.readonly.delete': '読み取り専用権限のため、プロバイダーを削除できません',
  'pages.admin.providerCard.warning.readonly.edit': '読み取り専用権限のため、プロバイダーを編集できません',
  'pages.admin.providerCard.warning.readonly.toggle': '読み取り専用権限のため、ステータスを切り替えできません',
  'pages.admin.providerCard.button.disable': '無効',
  'pages.admin.providerCard.button.enable': '有効',
  'pages.admin.providerCard.button.testing': 'テスト中...',
  'pages.admin.providerCard.button.test': 'テスト',
  'pages.admin.providerCard.button.edit': '編集',
  'pages.admin.providerCard.button.delete': '削除',
  'pages.admin.providerCard.delete.title': 'この項目を削除してもよろしいですか？',
  'pages.admin.providerCard.delete.content': '削除後は復元できません。操作を確認してください。',
  'pages.admin.providerCard.config.type': 'タイプ',
  'pages.admin.providerCard.config.apiUrl': 'API URL',
  'pages.admin.providerCard.config.model': 'モデル',
  'pages.admin.providerCard.config.apiKey': 'APIキー',
  'pages.admin.providerCard.config.temperature': '温度',
  'pages.admin.providerCard.config.maxTokens': '最大トークン数',
  'pages.admin.providerCard.config.appid': 'アプリID',
  'pages.admin.providerCard.config.cluster': 'クラスター',
  'pages.admin.providerCard.config.accessToken': 'アクセストークン',
  'pages.admin.providerCard.config.grpcHost': 'gRPCホスト',
  'pages.admin.providerCard.config.grpcPort': 'gRPCポート',
  'pages.admin.providerCard.config.voice': '音声',
  'pages.admin.providerCard.config.format': 'フォーマット',
  'pages.admin.providerCard.config.token': 'トークン',
  'pages.admin.providerCard.config.outputDir': '出力ディレクトリ',
  'pages.admin.providerCard.voices.supported': 'サポートされる音声',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': 'テストに失敗しました',

    // OpsManage
  'pages.admin.ops.service.title': 'サービス管理',
  'pages.admin.ops.upload.button': 'サービスファイルアップロード',
  'pages.admin.ops.upload.success': 'サービスファイルが正常にアップロードされました',
  'pages.admin.ops.upload.error': 'サービスファイルのアップロードに失敗しました',
  'pages.admin.ops.restart.button': 'サービス再起動',
  'pages.admin.ops.restart.confirmTitle': '注意：サービスを再起動してもよろしいですか？',
  'pages.admin.ops.restart.desc': 'サービスを再起動すると、すべての現在の接続が切断され、サービスが一時的に利用できなくなります。',
  'pages.admin.ops.restart.warn': 'この操作は現在のサービスプロセスのみを停止します。サーバーでデーモンまたは自動再起動スクリプトが設定されていることを確認してください。そうでなければ、サービスは自動的に回復しません！',
  'pages.admin.ops.restart.ok': '再起動確認',
  'pages.admin.ops.restart.cancel': 'キャンセル',
  'pages.admin.ops.restart.success': 'サービス再起動コマンドが送信されました',
  'pages.admin.ops.restart.error': 'サービス再起動に失敗しました',
  'pages.admin.ops.log.title': 'ログ表示とダウンロード',
  'pages.admin.ops.web.upload.button': 'web.zipアップロード',
  'pages.admin.ops.web.upload.success': 'web.zipが正常にアップロードされました',
  'pages.admin.ops.web.upload.error': 'web.zipのアップロードに失敗しました',
  'pages.admin.ops.web.upload.onlyzip': 'zipファイルのみ許可されています',
  'pages.admin.ops.web.update.button': 'webディレクトリ更新',
  'pages.admin.ops.web.update.success': 'webディレクトリ更新コマンドが送信されました',
  'pages.admin.ops.web.update.error': 'webディレクトリ更新に失敗しました',
  'pages.admin.ops.web.upload.onlywebzip': 'web.zipという名前のファイルのみ許可されています',

  // Recorder Management
  'pages.admin.recorder.title': 'デバイスレコーダー管理',
  'pages.admin.recorder.inputDeviceId': 'デバイスIDを入力してください',
  'pages.admin.recorder.inputPlaceholder': 'デバイスIDを入力してください',
  'pages.admin.recorder.search': '検索',
  'pages.admin.recorder.list.title': 'レコーダーリスト',
  'pages.admin.recorder.fetchSuccess': 'レコーダーレコードの取得に成功しました',
  'pages.admin.recorder.fetchError': 'レコーダーリストの取得に失敗しました',
  'pages.admin.recorder.empty': 'レコーダーデータがありません。デバイスIDを入力して検索してください',
  'pages.admin.recorder.totalCount': '統計',
  'pages.admin.recorder.conversationId': '会話ID',

  'pages.agentSetting.mcp.modal.title': 'MCPエンドポイント設定',
  'pages.agentSetting.mcp.modal.statusLabel': 'エンドポイントステータス',
  'pages.agentSetting.mcp.modal.online': 'オンライン',
  'pages.agentSetting.mcp.modal.disconnected': '切断',
  'pages.agentSetting.mcp.modal.unknown': '不明',
  'pages.agentSetting.mcp.modal.refresh': '更新',
  'pages.agentSetting.mcp.modal.enabledServices': '有効なサービス',
  'pages.agentSetting.mcp.modal.endpointLabel': 'エンドポイントアドレス',
  'pages.agentSetting.mcp.modal.endpointDesc': '以下はエージェントのMCPエンドポイントアドレスです。',
  'pages.agentSetting.mcp.modal.docLink': 'エンドポイントドキュメントを表示',
  'pages.agentSetting.mcp.modal.noEndpoint': '利用可能なエンドポイントがありません',
  'pages.agentSetting.mcp.modal.hide': '非表示',
  'pages.agentSetting.mcp.title': 'MCP設定', 
  'pages.agentSetting.mcp.customService': 'カスタムサービス',
  'pages.agentSetting.mcp.officialServices': '公式サービス',
  'pages.agentSetting.mcp.officialServices.placeholder': '公式サービスを選択',
  'pages.agentSetting.mcp.services.weather': '天気',
  'pages.agentSetting.mcp.services.joke': 'ジョーク',
  'pages.agentSetting.mcp.services.music': '音楽',
  'pages.agentSetting.mcp.services.news': 'ニュース',
  'pages.agentSetting.mcp.error.missingId': 'エージェントIDが不足しているため、エンドポイントを取得できません',
  'pages.agentSetting.mcp.error.noEndpoint': 'サーバーからエンドポイントを取得できません',
'pages.agentSetting.mcp.error.fetchFailed': 'エンドポイントの取得に失敗しました',
  'pages.agentSetting.mcp.button.getEndpoint': 'MCPエンドポイントを取得',

  // Memory settings
  'pages.agentSetting.memory.title': '短期メモリ',
  'pages.agentSetting.memory.type.label': 'メモリタイプ',
  'pages.agentSetting.memory.type.none': 'メモリなし',
  'pages.agentSetting.memory.type.shortTerm': '短期メモリ',
  'pages.agentSetting.memory.current.label.short': '現在のメモリ',
  'pages.agentSetting.memory.current.help': '各対話後に再生成',
  'pages.agentSetting.memory.clear': 'メモリをクリア',
  'pages.agentSetting.memory.clear.tip': 'メモリはクリア対象としてマークされました。保存をクリックして適用してください',
  'pages.agentSetting.memory.content.label': 'メモリ内容',
  'pages.agentSetting.memory.content.placeholder': 'エージェントの最新短期メモリコンテンツを取得',
  'pages.agentSetting.memory.content.editPlaceholder': 'メモリ内容を入力してください',
  'pages.agentSetting.memory.edit': 'メモリを編集',
  'pages.agentSetting.memory.edit.success': 'メモリが更新されました。保存をクリックして適用してください',
  'pages.agentSetting.memory.edit.save': '変更を保存',
  'pages.agentSetting.memory.edit.cancel': 'キャンセル',

  // 共通ボタンと操作
  'pages.common.cancel': 'キャンセル',

  // システム設定関連
  'pages.admin.systemConfig.roleName': 'ロール名',
  'pages.admin.systemConfig.roleDesc': 'ロールの説明',
  'pages.admin.systemConfig.enabled': '有効な状態',
  'pages.admin.systemConfig.featureName': '機能名',
  'pages.admin.systemConfig.featureDesc': '機能の説明',
  'pages.admin.systemConfig.exitCommand': '退出コマンド',
  'pages.admin.systemConfig.mcpName': 'MCP名',
  'pages.admin.systemConfig.newNameOptional': '新しい名前（オプション）',
  'pages.admin.systemConfig.configJson': '設定JSON',
  'pages.admin.systemConfig.useDeviceCode': 'デバイスコードを使用',
  'pages.admin.systemConfig.quickReply': 'クイックリプライ',
  'pages.admin.systemConfig.shortTermMemory': '短期記憶',
  'pages.admin.systemConfig.saveUserAudio': 'ユーザーオーディオファイルを保存',
  'pages.admin.systemConfig.enableWhiteList': 'ホワイトリストを有効にする',
  'pages.admin.systemConfig.speakerDetect': '話者認識',
  'pages.admin.systemConfig.recorderManagerEnable': 'レコーダー管理を有効にする',
  'pages.admin.systemConfig.voiceCloneEnable': 'ボイスクローンを有効にする',
  'pages.admin.systemConfig.flattenedChatHistory': 'フラット化されたチャット履歴',
  'pages.admin.systemConfig.dialogueHistoryLength': '対話履歴の長さ',
  'pages.admin.systemConfig.userTotalQuota': 'ユーザーの合計クォータ',
  'pages.admin.systemConfig.dailyClearQuota': '毎日のクォータをクリア',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'デバイスモードをすぐにチェック',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': '新規登録ユーザーのデフォルトオブザーバーロール',
  'pages.admin.systemConfig.status': '有効な状態',
  'pages.admin.systemConfig.port': 'ポート',
  'pages.admin.systemConfig.udpShowPort': 'ポートを表示',
  'pages.admin.systemConfig.accessToken': 'アクセストークン',
  'pages.admin.systemConfig.activateText': 'アクティブテキスト',
  'pages.admin.systemConfig.logLevel': 'ログレベル',
  'pages.admin.systemConfig.logDir': 'ログディレクトリ',
  'pages.admin.systemConfig.logFileName': 'ログファイル名',

  // ボイスクローン関連
  'pages.console.voiceClone.name': '名前',
  'pages.console.voiceClone.provider': 'プロバイダー',
  'pages.console.voiceClone.mode': 'モード',
  'pages.console.voiceClone.record': '録音',
  'pages.console.voiceClone.upload': 'アップロード',

  // 話者認識関連
  'pages.console.speakers.name': '名前',
  'pages.console.speakers.mode': 'モード',
  'pages.console.speakers.record': '録音',
  'pages.console.speakers.upload': 'アップロード',

  // 設定ページ関連
  'pages.console.settings.email': 'メール',
  'pages.console.settings.oldPassword': '旧パスワード',
  'pages.console.settings.newPassword': '新パスワード',
  'pages.console.settings.confirmNewPassword': '新パスワードを確認',

  // VLLMプロバイダー関連
  'pages.providers.vllm.maxPixels': '最大ピクセル数',
  'pages.admin.providerModal.copyAsNew': '新しいプロバイダーとしてコピー',

  'pages.unbindDevice.cardTitle': 'デバイス解除',
  'pages.whiteList.cardTitle': 'ホワイトリスト管理',
  'pages.admin.ops.logViewer.previewTitle': 'ログプレビュー',
  'pages.admin.ops.logViewer.fileName': 'ファイル名：',
  'pages.admin.ops.logViewer.lineCount': '行数：',
  'pages.admin.ops.logViewer.previewBtn': 'プレビュー',
  'pages.admin.ops.logViewer.noContent': 'コンテンツなし',
  'pages.admin.devices': 'デバイス管理',
  'pages.admin.unbindDevice': 'デバイス解除',
  'pages.admin.deviceManage': 'デバイス管理',
  'pages.systemConfig.quickReply': 'クイックリプライ',
  'pages.systemConfig.useShortTermMemory': '短期記憶',
  'pages.systemConfig.useShortTermMemory.desc': '有効にすると、システムは短期記憶メカニズムを使用し、各対話の後に短期記憶を更新します。無効にすると、短期記憶は使用されません。',
  'pages.agentSetting.mcp.modal.show': '表示',
  'pages.agentSetting.mcp.modal.copied': 'コピー済み',
  'pages.agentSetting.mcp.modal.copy': 'コピー',
  'pages.admin.providerModal.model.label': 'モデル *',
  'pages.admin.providerModal.model.placeholder': 'モデル名を入力してください',
  'pages.admin.providerModal.model.required': 'モデル名を入力してください',
  'pages.admin.providerModal.security.title': 'セキュリティ設定',
  'pages.admin.providerModal.appid.placeholder': '豆包アプリID',
  'pages.admin.providerModal.accessToken.placeholder': 'アクセストークン',
  'pages.admin.providerModal.grpc.addr.label': 'gRPCアドレス（ホスト:ポート）*',
  'pages.admin.providerModal.grpc.addr.required': 'gRPCアドレス（ホスト:ポート）を入力してください',
  'pages.admin.providerModal.token.placeholder': '豆包トークン',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'APIキー',
  'pages.admin.providerModal.manageVoices': 'ボイス管理',
  'pages.admin.whiteList.inputMac': 'MACアドレスを入力してください',
  'pages.admin.whiteList.batchAdd': '一括追加',
  'pages.admin.whiteList.add': '追加',
  'pages.admin.whiteList.list.title': 'MACアドレスリスト',
  'pages.admin.whiteList.selectCsvTip': 'CSVファイルを選択してください',
  'pages.admin.whiteList.uploadSuccess': 'アップロード成功',
  'pages.admin.whiteList.uploadFailed': 'アップロード失敗',
  'pages.admin.whiteList.invalidMac': '有効なMACアドレスを入力してください',
  'pages.admin.settings.voiceCloneEnable': 'ボイスクローンを有効にする',
  'pages.agentSetting.roleTemplate.empty': 'テンプレートがありません。role_template.jsonを確認してください',
  'pages.admin.providerModal.save': '保存',
  'pages.contractDevice.cardTitle': '契約デバイス管理',
  'pages.contractDevice.mac': 'MACアドレス',
  'pages.contractDevice.protocolType': 'プロトコルタイプ',
  'pages.contractDevice.status': 'ステータス',
  'pages.contractDevice.expireTime': '有効期限',
  'pages.contractDevice.updateTime': '更新時間',
  'pages.contractDevice.operations': '操作',
  'pages.contractDevice.edit': '編集',
  'pages.contractDevice.delete': '削除',
  'pages.contractDevice.deleteConfirm': '削除を確認',
  'pages.contractDevice.addTitle': '契約デバイスを追加',
  'pages.contractDevice.batchAddTitle': '一括追加',
  'pages.contractDevice.editTitle': '契約デバイスを編集',
  'pages.contractDevice.listTitle': '契約デバイスリスト',
  'pages.contractDevice.add': '追加',
  'pages.contractDevice.batchAdd': '一括追加',
  'pages.contractDevice.selectCsvTip': 'CSVファイルを選択してください',
  'pages.contractDevice.uploadSuccess': 'アップロード成功',
  'pages.contractDevice.macRequired': 'MACアドレスを入力してください',
  'pages.contractDevice.protocolTypeRequired': 'プロトコルタイプを選択してください',
  'pages.contractDevice.statusRequired': 'ステータスを選択してください',
  'pages.contractDevice.expireTimeRequired': '有効期限を選択してください',
};